import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable import/extensions */
import React, { useRef, useLayoutEffect } from 'react';
import { SSRsearchInputField, SSRsearchInputContainer, SSRdesktopSearchIconWrapper, SSRmobileSearchIconWrapper, SSRformContainer, SSRsearchInputWrapper } from './search-input.styled';
// @ts-ignore
import { script } from './ssr-scripts/min-script-interactive-search-input';
import { SearchIcon } from '../icons';
export var SSRsearchInput = function SSRsearchInput(_ref) {
  var advancedSearchUrl = _ref.advancedSearchUrl,
    placeholder = _ref.placeholder,
    customScriptDataAttributes = _ref.customScriptDataAttributes,
    theme = _ref.theme,
    shouldFillContainer = _ref.shouldFillContainer;
  var scriptRef = useRef(null);
  useLayoutEffect(function () {
    var current = scriptRef === null || scriptRef === void 0 ? void 0 : scriptRef.current;
    if (current) {
      // eslint-disable-next-line
      eval(current.innerHTML);
    }
  });
  return /*#__PURE__*/React.createElement(SSRsearchInputWrapper, null, /*#__PURE__*/React.createElement("div", {
    id: "ssr-search-input-popout-container"
  }, /*#__PURE__*/React.createElement(SSRformContainer, {
    id: "ssr-form-container"
  }, /*#__PURE__*/React.createElement("form", {
    method: "get",
    action: advancedSearchUrl
  }, /*#__PURE__*/React.createElement(SSRsearchInputContainer, {
    shouldFillContainer: shouldFillContainer,
    id: "ssr-input-container",
    role: "search"
  }, /*#__PURE__*/React.createElement(SSRmobileSearchIconWrapper, null, /*#__PURE__*/React.createElement(SearchIcon, {
    theme: theme,
    isExpanded: false,
    size: "medium"
  })), /*#__PURE__*/React.createElement(SSRdesktopSearchIconWrapper, {
    id: "ssr-search-icon-wrapper"
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    theme: theme,
    isExpanded: false
  })), /*#__PURE__*/React.createElement(SSRsearchInputField, {
    id: "ssr-search-input",
    name: "text",
    placeholder: placeholder,
    autoComplete: "off",
    "aria-label": placeholder
  })), /*#__PURE__*/React.createElement("script", _extends({
    "data-test-id": "ssr-scripts-init",
    ref: scriptRef,
    dangerouslySetInnerHTML: {
      __html: script
    }
  }, customScriptDataAttributes))))));
};